import { render, staticRenderFns } from "./GenerateDataImportFileButton.vue?vue&type=template&id=4836d718&scoped=true&"
import script from "./GenerateDataImportFileButton.vue?vue&type=script&lang=js&"
export * from "./GenerateDataImportFileButton.vue?vue&type=script&lang=js&"
import style0 from "./GenerateDataImportFileButton.vue?vue&type=style&index=0&id=4836d718&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4836d718",
  null
  
)

export default component.exports